var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconUpdated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6998 0.1H8.2998V9.15527V9.36878L8.46382 9.2321L11.3178 6.8538L12.4342 7.78418L7.4998 11.8962L2.56538 7.78418L3.68184 6.8538L6.53579 9.2321L6.6998 9.36878V9.15527V0.1ZM14.5998 14.9H0.399805V13.6H14.5998V14.9Z",
    fill: "currentFill",
    stroke: "none",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconUpdated);
export default __webpack_public_path__ + "static/media/downloadIconUpdated.0706b3ab74129b334e6283944c0b3235.svg";
export { ForwardRef as ReactComponent };